module.exports = __webpack_public_path__ + "img/table-benefits-comparison.5b1499de.png";